import PropTypes from 'prop-types';
import React from 'react';
import IntersectionObserver from '../IntersectionObserver';
import RenderGenericChildren from '../RenderGenericChildren';

class OnVisibleInViewport extends React.Component {
  intersectionCallback = (entry) => {
    const { onVisible } = this.props;
    if (entry.isIntersecting) {
      onVisible();
    }
  };

  render() {
    const { children, style, thresholdMargin, threshold } = this.props;

    return (
      <IntersectionObserver
        callback={this.intersectionCallback}
        style={style}
        thresholdMargin={thresholdMargin}
        threshold={threshold}
      >
        <RenderGenericChildren>{children}</RenderGenericChildren>
      </IntersectionObserver>
    );
  }
}

OnVisibleInViewport.propTypes = {
  thresholdMargin: PropTypes.string,
  style: PropTypes.object,
  onVisible: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  threshold: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]),
};

export default OnVisibleInViewport;
